export default function () {
    document.addEventListener('DOMContentLoaded', () => {
        const $navbarToggler = document.querySelector('#navbar-toggler');
        const $firstLevelNav = document.querySelector('.nav-level-1');
        const $mobileNavScrollBox = document.getElementById('nav-drill-mobile');
        const navExpand = [].slice.call(document.querySelectorAll('.nav-expand'));

        navExpand.forEach((item) => {
            item.querySelector('.nav-link').addEventListener('click', () => {
                $mobileNavScrollBox.scrollTop = 0;
                item.classList.add('active');
                $firstLevelNav.classList.add('invisible');
            });
            item.querySelector('.nav-expand-link').addEventListener('click', (event) => {
                event.preventDefault();
            });
            item.querySelector('.nav-back-link').addEventListener('click', () => {
                item.classList.remove('active');
                $firstLevelNav.classList.remove('invisible');
            });
        });

        $navbarToggler.addEventListener('click', () => {
            document.body.classList.toggle('nav-is-toggled');
            $navbarToggler.classList.toggle('active');
        });
    });
}
